export enum AnalyticEvents {
  VIEWED = "Viewed",
  VIEWABLE = "Viewable",
  CLICKED_THROUGH = "Clicked-through",
  ERROR = "Error",
  INTERACTED = "Interacted"
}

export interface Pixels {
  impression: string;
  clickThrough: string;
}

export interface AnalyticsContext {
  viewID: string;
  emit: boolean;
  pixels: Pixels;
  statsURL: string;
  operator: string;
  isViewabilityDetectable: boolean;
  catalogueID: string;
  pageUrl: string;
  externalID: string;
  customField: CustomField;
  campaignID?: string;
  campaignName?: string;
  espnOfferDisplayed: boolean;
}

export interface CustomField {
  customField1?: string | null;
  customField2?: string | null;
  customField3?: string | null;
  customField4?: string | null;
  customField5?: string | null;
}

export interface AnalyticsBet {
  betOptionID: string;
  betID: string;
}

export interface AnalyticsRequest {
  bets: AnalyticsBet[];
  viewID: string;
  version: string;
  operator: string;
  statsEventName: string;
  statsEventDescription: string;
  isViewabilityDetected: number;
  adScreenHeight: number;
  adScreenWidth: number;
  catalogueID: string;
  stakeCurrency?: string;
  stakeAmount?: number;
  pageUrl: string;
  externalID: string;
  campaignID?: string;
  campaignName?: string;
  customField1?: string;
  customField2?: string;
  customField3?: string;
  customField4?: string;
  customField5?: string;
  espnOfferDisplayed: boolean;
}
